module.exports = "import React from \"react\";\n\nimport { GithubCorner } from \"../../lib\";\n\nexport default () => (\n  <div style={{ height: \"100px\"}}>\n    <GithubCorner />\n  </div>);\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/GithubCorner/demo/default.js
// module id = 133
// module chunks = 0